import React, { useContext, useEffect } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import "./style.css";
import BottomSheetChip from "./SheetElements/BottomSheetChip";
import BottomSheetTab from "./SheetElements/BottomSheetTab";
import MyInput from "../../MyInput";
import { useState } from "react";
import { getDataFromApi } from "../../../APIs";
import { filterDataContext } from "../../../App";
import { POPULARVENUES_API } from "../../../constants";
import {
  chipDateShow,
  formatDate,
  getCrossIcon,
  getPopularApiByTabs,
  priceRangeShow,
} from "../../../utils/func";
import {
  TabContent,
  countriesList,
  createTabContentData,
} from "../../../constants/TextContainer";
import { DownArrowIcon, SearchIcon } from "../../GlobalIcons";
import DateSelect from "../../Filter/FilterSorting/DateSelect";
import PriceRange from "../../Filter/FilterSorting/PriceRange";
import AvailabilitySorting from "../../Filter/FilterSorting/Availability";
import LocationSorting from "../../Filter/FilterSorting/Location";
import { createSearchParams, useNavigate } from "react-router-dom";
import { EVENTSPAGE } from "../../../constants/RoutingPath";
import Tabination from "../Tabination";
import ResultChip from "../../ResultChip";
import MobileBottomSheetLoader from "../../Loaders/Home/MobileBottomSheetLoader";
import NoResultFound from "../../NoResultFound";

const BottomSheetContent = [
  {
    id: 1,
    Name: "Manchaster",
  },
  {
    id: 2,
    Name: "AS Roma",
  },
  {
    id: 3,
    Name: "Arsenal FC",
  },
];
const BottomSheetContent1 = [
  {
    id: 1,
    Name: "AS Roma",
  },
  {
    id: 2,
    Name: "Arsenal FC",
  },
  {
    id: 3,
    Name: "AS Roma",
  },
  {
    id: 4,
    Name: "Benfica",
  },
  {
    id: 5,
    Name: "Celtic",
  },
  {
    id: 6,
    Name: "Chelsea FC",
  },
];

const MobileBottomSheet = ({
  setBottomSheetView,
  bottomSheetview,
  searchParams,
  setSearchParams,
}) => {
  const {
    selectedSport,
    currentSortingTab,
    setCurrentSortingTab,
    filterChips,
    setFilterChips,
    filteredParams,
    preloadTournamentData,
    setMaxPriceInput,
    setMinPriceInput,
    setTicketAvailabiltyInput,
    popularData,
    searchResult,
    setSearchResult,
    filterSearchInput,
    setFilterSearchInput,
    filteredEvents,
    setShowSorting,
    showSorting,
    setViewMoreClicked,
    checkTeamDataLength,
    setCheckTeamDataLength,
    filterLoader,
  } = useContext(filterDataContext);
  const navigate = useNavigate();
  const itemsPerPage = 5;
  const [visibleItems, setVisibleItems] = useState(itemsPerPage);

  const handleMobileSortTab = (name) => {
    setCurrentSortingTab(name);
  };

  const handleResetFilters = () => {
    setSearchParams({ sport_type: searchParams.get("sport_type") });
    setMaxPriceInput("");
    setMinPriceInput("");
    setTicketAvailabiltyInput("");
    setFilterSearchInput("");
  };

  useEffect(() => {
    if (filterSearchInput.length > 0) {
      setVisibleItems(itemsPerPage);
    }
  }, [filterSearchInput]);

  const createFilterParams = (item) => {
    setFilterSearchInput("");
    const paramsToUpdate = {};
    if (item.official_name && item.team_id) {
      paramsToUpdate.team_name = item.official_name;
    }
    if (item.official_name && item.tournament_id) {
      paramsToUpdate.tournament_name = item.slug;
    }

    if (item.country_name || item.city_Name || item.venueFilter_id) {
      searchParams.delete("country");
      searchParams.delete("city");
      searchParams.delete("venue");
      if (item.country_name) paramsToUpdate.country = item.iso;
      if (item.city_Name) paramsToUpdate.city = item.city_Name;
      if (item.venueFilter_id) paramsToUpdate.venue = item.venue_Name;
    }

    if (item.date) {
      if (item.date.includes("/")) {
        const [date_start, date_stop] = item.date.split("/");
        paramsToUpdate.date_start = date_start;
        paramsToUpdate.date_stop = date_stop;
      } else {
        searchParams.delete("date_stop");
        paramsToUpdate.date_start = item.date;
      }
    }
    if (item.price || item.minPriceInput || item.maxPriceInput) {
      if (item.price) {
        const [minPrice, maxPrice] = item.price.split("/");
        paramsToUpdate.minPrice = minPrice;
        paramsToUpdate.maxPrice = maxPrice;
      }
      if (item.minPriceInput) {
        searchParams.delete("maxPrice");
        paramsToUpdate.minPrice = item.minPriceInput;
      }
      if (item.maxPriceInput) {
        paramsToUpdate.minPrice = 0;
        paramsToUpdate.maxPrice = item.maxPriceInput;
      }
    }
    if (item.tickets_Avalability) {
      paramsToUpdate.ticket_Availability = item.tickets_Avalability;
    }

    for (const [key, value] of Object.entries(paramsToUpdate)) {
      if (value !== undefined) {
        searchParams.set(key, value);
      }
    }
    setSearchParams(searchParams);
  };

  const showMoreItems = () => {
    const newVisibleItems = visibleItems + itemsPerPage;
    setVisibleItems(Math.min(newVisibleItems, searchResult.length));
  };

  const closeBottomSheet = () => {
    setShowSorting(false);
    setBottomSheetView(false);
  };

  const handleEventRouting = () => {
    navigate({
      pathname: EVENTSPAGE,
      search: createSearchParams(searchParams).toString(),
    });

    setBottomSheetView(false);
    setShowSorting(!showSorting);
    setViewMoreClicked(true);
  };

  useEffect(() => {
    if (filteredParams.length > 0) {
      getCrossIcon();
    }
  }, [filteredParams]);

  const setSortingTabFromChips = (key) => {
    if (key === "team_name") {
      setCurrentSortingTab("Team");
    } else if (key === "venue" || key === "city" || key === "country") {
      setCurrentSortingTab("Location");
    } else if (key === "date") {
      setCurrentSortingTab("Date");
    } else if (key === "ticket_Availability") {
      setCurrentSortingTab("Availability");
    } else if (key === "price") {
      setCurrentSortingTab("Price-Range");
    } else if (key === "tournament_name") {
      setCurrentSortingTab("Competition");
    }
  };
  const handleOpenEvent = (eventName) => {
    navigate({
      pathname: `/ticket/${eventName}`,
    });
  };

  return (
    <div className="black_bottom_sheet">
      <BottomSheet
        blocking={true}
        className="sheet_sec"
        onDismiss={closeBottomSheet}
        expandOnContentDrag
        open={bottomSheetview}
        snapPoints={({ maxHeight }) => {
          return [420, maxHeight - (maxHeight * 30) / 100, maxHeight - 74];
        }}
        sibling={
          <div
            style={{
              position: "absolute",
              bottom: "1px",
              // left: "calc(1vw - 1px)",
              zIndex: 4,
              width: "98vw",
              // height: "calc(7vh - 3px)",
              // border: "1px solid black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // color: "black",
              // background: "white",
            }}
          >
            <Tabination />
          </div>
        }
      >
        <div className="bottomsheet_section">
          <div className="sheet_sec1">
            <div className="sheet_sec_chips">
              {filterChips?.map((item, index) => {
                return (
                  <BottomSheetChip
                    name={item.value}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    key={index}
                    removeKey={item.key}
                    filterChips={"filterChips"}
                    setSortingTabFromChips={setSortingTabFromChips}
                  />
                );
              })}
            </div>
            <div className="sheet_sec2">
              <button onClick={handleResetFilters}>Reset filter</button>
            </div>
          </div>
          <div className="sheet_sec3">
            <div className="leftsheet_sec">
              {createTabContentData(currentSortingTab)
                .filter((item) => {
                  if (checkTeamDataLength === true) {
                    return item.CategoryName !== "Team";
                  } else {
                    return item;
                  }
                })
                .map((item, index) => (
                  <BottomSheetTab
                    key={index}
                    handleMobileSortTab={handleMobileSortTab}
                    currentSortingTab={currentSortingTab}
                    item={item}
                    filteredParams={filteredParams}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    crossIcon={getCrossIcon(item.CategoryName, filteredParams)}
                  />
                ))}
            </div>
            <div className="rightsheet_sec search_anad_result">
              <div className="search_bar">
                <h6>
                  {currentSortingTab === "Date" &&
                    `Select ${currentSortingTab} Range`}
                  {currentSortingTab === "Team" &&
                    `Search ${currentSortingTab}`}
                  {currentSortingTab === "Competition" &&
                    `Search ${currentSortingTab}`}
                  {currentSortingTab === "Location" &&
                    `Search ${currentSortingTab}`}
                  {currentSortingTab === "Availability" &&
                    `Search ${currentSortingTab}`}
                  {currentSortingTab === "Price-Range" &&
                    `Enter ${currentSortingTab}`}
                </h6>
              </div>
              <div className="search_bar">
                {currentSortingTab === "Team" ||
                currentSortingTab === "Competition" ||
                currentSortingTab === "Location" ? (
                  <>
                    <MyInput
                      inputType={"text"}
                      placeholderText="Search"
                      value={filterSearchInput}
                      func={setFilterSearchInput}
                    />
                    <span className="sheet_search_icon">
                      <SearchIcon />
                    </span>
                  </>
                ) : (
                  <>
                    {currentSortingTab === "Date" && (
                      <h3 className="date_picker_mobile">
                        <DateSelect
                          createFilterParams={createFilterParams}
                          searchParams={searchParams}
                          setSearchParams={setSearchParams}
                        />
                      </h3>
                    )}
                    {currentSortingTab === "Price-Range" && (
                      <PriceRange
                        createFilterParams={createFilterParams}
                        currentSortingTab={currentSortingTab}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                      />
                    )}
                    {currentSortingTab === "Availability" && (
                      <AvailabilitySorting
                        currentSortingTab={currentSortingTab}
                        createFilterParams={createFilterParams}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                      />
                    )}
                  </>
                )}
              </div>
              <div className="popular_section">
                {filterSearchInput.length === 0 &&
                popularData.length > 0 &&
                filteredParams.length === 0 ? (
                  <h3> Showing Popular {currentSortingTab}</h3>
                ) : (
                  <h3></h3>
                )}

                <div className="chips_popular">
                  {filterLoader === true ? (
                    <>
                      <MobileBottomSheetLoader />
                      <MobileBottomSheetLoader />
                      <MobileBottomSheetLoader />
                    </>
                  ) : (
                    <>
                      {filterSearchInput.length === 0 &&
                      filteredParams.length > 0 ? (
                        filteredEvents &&
                        (filteredEvents.length > 0 ? (
                          <>
                            {filteredEvents.slice(0, 3).map((item, index) => (
                              <BottomSheetChip
                                name={item.event_name}
                                key={index}
                                item={item}
                                detail={formatDate(item.date_start)}
                                handleOpenEvent={handleOpenEvent}
                              />
                            ))}
                            {filteredEvents.length > 5 && (
                              <button
                                className="view_more_filter"
                                onClick={handleEventRouting}
                              >
                                View More
                                <span>
                                  <DownArrowIcon fill={"var(--black)"} />
                                </span>
                              </button>
                            )}
                          </>
                        ) : (
                          <NoResultFound heading={"No Events"} />
                        ))
                      ) : filterSearchInput.length > 0 ? (
                        <>
                          {currentSortingTab === "Location" && (
                            <LocationSorting
                              perPage={5}
                              filterSearchInput={filterSearchInput}
                              createFilterParams={createFilterParams}
                            />
                          )}
                          {currentSortingTab !== "Location" && (
                            <>
                              {searchResult
                                .slice(0, visibleItems)
                                .map((item, index) => (
                                  <BottomSheetChip
                                    name={
                                      item.event_name
                                        ? item.event_name
                                        : item.official_name
                                    }
                                    key={index}
                                    item={item}
                                    createFilterParams={createFilterParams}
                                    detail={
                                      currentSortingTab === "Competition" &&
                                      formatDate(item.date_start)
                                    }
                                  />
                                ))}
                              {searchResult.length > 5 &&
                              searchResult.length > visibleItems ? (
                                <button
                                  className="view_more_filter"
                                  onClick={showMoreItems}
                                >
                                  View More
                                  <span>
                                    <DownArrowIcon fill={"var(--black)"} />
                                  </span>
                                </button>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        popularData.length > 0 &&
                        popularData?.map((item, index) => (
                          <BottomSheetChip
                            key={index}
                            name={
                              item.venue_Name
                                ? item.venue_Name
                                : item.official_name
                                ? item.official_name
                                : ""
                            }
                            item={item}
                            createFilterParams={createFilterParams}
                          />
                        ))
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

export default MobileBottomSheet;
